import React from 'react'
import classNames from 'classnames'

export default function Title ({ children, black = false }) {
  return (
    <h2 className={classNames('lc-title', {
      'lc-title--black': black
    })}>{children}</h2>
  )
}
